export const ERROR_MESSAGES: Record<string, string> = {
    USER_NOT_FOUND: "Пользователь не найден",
    USER_HAS_NO_COMPANY: "У пользователя нет компании",
    VACANCY_COMPANY_CODE_ALREADY_EXISTS: "Код компании вакансии уже существует",
    USER_NOT_FOUND_EMAIL: "Пользователь с таким Email не найден",
    INVALID_PASSWORD: "Неверный пароль, попробуйте еще раз",
    NOT_IMPLEMENTED: "Данное действие не поддерживается",
    USER_ALREADY_EXISTS: "Пользователь с таким Email уже существует",
    INVALID_TOKEN: "Неверный токен",
    NOT_FOUND_MEETING_TYPE: "Пожалуйста, заполните формат встречи",
    CONFLICT_EVENT: "На указанную дату или время уже запланировано другое событие"
};

export const getErrorMessage = (error: any, customMessage?: string): string => {
    const errorCode = error?.response?.data?.message;
    return ERROR_MESSAGES[errorCode] || `Ошибка: ${error?.message || customMessage || "Неизвестная ошибка"}`;
};